import { Observable } from 'rxjs';

export function observableToPromise<T>(obs$: Observable<T>): Promise<T> {
  return new Promise((resolve, reject) => {
    obs$.subscribe({
      next: (value) => resolve(value),
      error: (err) => reject(err),
    });
  });
}
